import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './WidgetHeaderContentTitle.module.css'

function WidgetHeaderContentTitle({
  Component = Text,
  className = styles.WidgetHeaderContentTitle,
  title,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <FloatingTooltip content={title} disabled={!overflow}>
      <Component className={className} ref={setContentOverflowRef}>
        {title}
      </Component>
    </FloatingTooltip>
  )
}

export default WidgetHeaderContentTitle
